import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUpRight, X } from 'lucide-react';
import { Button } from './ui/Button';

export const DISCORD_URL = 'https://discord.gg/ZKSWY3PjYp';

export function UnlockInfoModal({ open, onClose, showDiscord = true }) {
  return (
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-[70] flex items-center justify-center p-6">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/80 backdrop-blur-sm"
            onClick={onClose}
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 10 }}
            transition={{ type: 'spring', duration: 0.35 }}
            className="relative z-10 w-full max-w-sm rounded-3xl border border-emerald/30 bg-ink-card p-8 text-center shadow-inner_glow"
            data-testid="unlock-info-modal"
          >
            <button
              onClick={onClose}
              className="absolute right-4 top-4 text-zinc-500 hover:text-white"
              data-testid="unlock-info-close"
            >
              <X size={20} />
            </button>
            <div className="mx-auto grid h-16 w-16 place-items-center rounded-2xl bg-emerald/10 text-emerald">
              <ArrowUpRight size={28} />
            </div>
            <h2 className="mt-6 font-heading text-2xl font-bold tracking-tight text-white">
              DM Lander On Discord For More Information
            </h2>
            <a
              href={DISCORD_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="unlock-info-discord"
              className={`mt-5 flex w-full items-center justify-center gap-2 rounded-full bg-emerald py-3 text-sm font-bold text-black transition-transform hover:scale-[1.02] ${showDiscord ? '' : 'hidden'}`}
            >
              Join the free discord <ArrowUpRight size={16} />
            </a>
            <Button pill size="md" variant="outline" className={showDiscord ? 'mt-3 w-full' : 'mt-6 w-full'} onClick={onClose} data-testid="unlock-info-ok">
              Got it
            </Button>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
